import Lottie from "lottie-react";
import styles from "./index.module.less";
import useHoverLottie from "@/hooks/useHoverLottie";
import jiantou from "@/assets/lottie/jiantou.json";
import { useStore } from "@/stores";
import { Flex } from "antd";
const MobileP1Content = ({
  title,
  subtitle,
  link,
  contactText = "联系咨询",
  linkText = "立即体验",
  showBtn = true,
  btns,
  style,
}: {
  title: any;
  subtitle: string;
  link?: string;
  contactText?: string;
  linkText?: string;
  showBtn?: boolean;
  btns?: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const { lottieOptions, playLottieOnce, stopLottie } = useHoverLottie({
    animationData: jiantou,
  });
  const app = useStore("app");
  return (
    <div className={styles.mobileBanner} style={style}>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
        {showBtn && (
          <div
            className={styles.link}
            onClick={() => {
              if (link) {
                window.open(link, "_blank");
              } else {
                app.openContactModal();
              }
            }}
          >
            {link ? linkText : contactText}
            <Lottie className={styles.link_lottie} {...lottieOptions} />
          </div>
        )}
        {btns && <div className={styles.btns}>{btns}</div>}
      </div>
    </div>
  );
};
export default MobileP1Content;
